"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectModalComponent = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const antd_1 = require("antd");
const lodash_1 = __importDefault(require("lodash"));
const ProjectsProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/ProjectsProvider");
const PromiseUtils_1 = require("src/hello_assets/src/components/system/util/PromiseUtils");
const Form_1 = require("antd/lib/form/Form");
const Analytics_1 = require("src/hello_assets/src/util/analytics/Analytics");
/*specific*/
const PROJECT_NAME_MAXLENGTH = 200;
const formRules = {
    name: [{ required: true, message: "Name is required" }]
};
const modalButtonsPropsInitialValue = {
    ok: { disabled: true },
    cancel: {}
};
const ProjectModalComponent = (props) => {
    const projectsContext = (0, ProjectsProvider_1.useProjectsContext)();
    const [form] = (0, Form_1.useForm)();
    const [modalButtonProps, setModalButtonProps] = (0, react_1.useReducer)((state, newState) => ({ ...state, ...newState }), modalButtonsPropsInitialValue);
    const isCreate = lodash_1.default.isEmpty(props.projectView);
    const initialValues = { name: isCreate ? "" : props.projectView ? props.projectView.projectName : "" };
    const title = isCreate ? `Create Project` : "Rename Project";
    const okText = isCreate ? "Create" : "Rename";
    const createCancellable = (0, PromiseUtils_1.makeCancelableAsync)(async (projectName) => {
        return await projectsContext.createProject(projectName);
    });
    const renameCancellable = (0, PromiseUtils_1.makeCancelableAsync)(async (projectName) => {
        return await projectsContext.renameProject(props.projectView.projectApiKey, projectName);
    });
    const asyncRenameProject = async (formValues) => {
        try {
            const { name } = formValues;
            //disabled buttons
            setModalButtonProps({
                ok: { disabled: true, loading: true, },
                cancel: { disabled: true, }
            });
            try {
                const result = await renameCancellable.runAsyncFunc(name);
                // console.log("ProjectModalComponent: rename project ok", result)
                props.onDestroy();
            }
            catch (e) {
                const { isCanceled, error } = e;
                if (isCanceled) {
                    return;
                }
                else {
                    throw error;
                }
            }
        }
        catch (error) {
            console.error("ProjectModalComponent: rename project failed", error);
            //enabled buttons
            setModalButtonProps({
                ok: { disabled: false, loading: false, },
                cancel: { disabled: false, }
            });
            //update errors
            form && form.setFields([{ name: "name", errors: ["Project cannot be renamed. Please try again."] }]);
        }
    };
    const asyncCreateProject = async (formValues) => {
        try {
            const { name } = formValues;
            //disabled buttons
            setModalButtonProps({
                ok: { disabled: true, loading: true, },
                cancel: { disabled: true, }
            });
            try {
                const result = await createCancellable.runAsyncFunc(name);
                // console.log("ProjectModalComponent: create project ok", result)
                Analytics_1.Analytics.trackCreateProject();
                props.onDestroy();
            }
            catch (e) {
                const { isCanceled, error } = e;
                if (isCanceled) {
                    return;
                }
                else {
                    throw error;
                }
            }
        }
        catch (error) {
            console.error("ProjectModalComponent: create project failed", error);
            //enabled buttons
            setModalButtonProps({
                ok: { disabled: false, loading: false, },
                cancel: { disabled: false, }
            });
            //update errors
            form && form.setFields([{ name: "name", errors: ["Project cannot be created. Please try again."] }]);
        }
    };
    const onFormFieldsChange = (changedFields, allFields) => {
        let valid = true;
        for (const idx in allFields) {
            const field = allFields[idx];
            if (field.errors && field.errors.length > 0) {
                valid = false;
            }
        }
        setModalButtonProps({
            ok: { disabled: !valid }
        });
    };
    const onFormFinish = async (values) => {
        if (isCreate) {
            await asyncCreateProject(values);
        }
        else {
            await asyncRenameProject(values);
        }
    };
    const onCancel = () => {
        props.onDestroy();
    };
    const onOk = async () => {
        if (form) {
            const values = form.getFieldsValue();
            await onFormFinish(values);
        }
    };
    return React.createElement(antd_1.Modal, { closable: false, maskClosable: false, destroyOnClose: true, visible: props.visible, title: title, onCancel: onCancel, okText: okText, onOk: onOk, okButtonProps: modalButtonProps.ok, cancelButtonProps: modalButtonProps.cancel, className: "ug-modal" },
        React.createElement(antd_1.Form, { form: form, layout: "vertical", hideRequiredMark: true, initialValues: initialValues, onFinish: onFormFinish, onFieldsChange: onFormFieldsChange },
            React.createElement(antd_1.Form.Item, { name: "name", label: "Name", rules: formRules.name },
                React.createElement(antd_1.Input, { autoFocus: true, maxLength: PROJECT_NAME_MAXLENGTH }))));
};
exports.ProjectModalComponent = ProjectModalComponent;
